// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles({
  rotated: {
    transform: 'rotate(180deg)',
  },
});

interface Props {
  className?: string;
  rotated?: boolean;
}

const ArrowDownIcon = ({ className, rotated }: Props) => {
  const classes = useStyles();

  return <KeyboardArrowDownIcon className={classnames(className, { [classes.rotated]: rotated })} />;
};

export default ArrowDownIcon;
